import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 24.009 27.458',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="União_4"
      data-name="União 4"
      d="M20.4,30.84.734,19.486a.731.731,0,0,1-.267-1l.582-1.008a1.8,1.8,0,0,1,1.081-.762A16.1,16.1,0,0,0,11.8,10.2c4.224-6.458,7.476-4.215,9.248-3.192s5.342,2.719,1.86,9.606A16.091,16.091,0,0,0,22.1,28.249a1.8,1.8,0,0,1-.12,1.317L21.4,30.574a.732.732,0,0,1-.634.364A.72.72,0,0,1,20.4,30.84ZM8.816,29.162l-.837-.483c-1.151-.665-1.313-2.559-.648-3.71l5.022,2.9A3.213,3.213,0,0,1,9.76,29.4,1.872,1.872,0,0,1,8.816,29.162ZM22.2,6l-.232-.132-.2-.114-.2-.113L21.346,5.5a9.327,9.327,0,0,0-1.752-.807l.284-.492a1.456,1.456,0,0,1,1.982-.53l1.673.967a1.453,1.453,0,0,1,.531,1.98l-.284.492A9.318,9.318,0,0,0,22.2,6Z"
      transform="translate(-0.37 -3.479)"
      fill={fill}
    />
  </svg>
);

export default SVG;
